import CustomTable from "../../../../../components/table/CustomTable";
import React from "react";
import {AttendanceTableApp} from "../Functionality/AttendanceTableApp";
import AttendanceHead from "./AttendanceHead";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const AttendanceDayTable = ({
    selectedOption,
    searchElement,
    search,
    option,
    setSimpleSearch,
    setSearch,
    finalArray,
    setSearchElement,
    setBodyForExport,
    searchClean,
    contractorId,
    supplierId,
    setSendSimpleSearch,
    setSelectedOption,
    view,
    setView,
    color,
    setCriteria,
    modified,
    setModified,
    handleView,
    prevIsDaily
}) => {


    const {
        attendanceStartDate,
        attendanceEndDate,
        rowsPerPage,
        tableId,
        thead,
        tbody,
        pagination,
        searchId,
        setResults,
        selectedDate,
        setSelectedDate,
    } = AttendanceTableApp({
        selectedOption,
        searchElement,
        option,
        finalArray,
        color,
        setCriteria,
        setBodyForExport,
        modified,
        setModified,
        prevIsDaily
    })

    return (
        <>
            <AttendanceHead
                view={view}
                setView={setView}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                rowsPerPage={rowsPerPage}
                attendanceStartDate={attendanceStartDate}
                attendanceEndDate={attendanceEndDate}
                selectedOption={selectedOption}
                setSimpleSearch={setSimpleSearch}
                searchClean={searchClean}
                setSearch={setSearch}
                contractorId={contractorId}
                supplierId={supplierId}
                search={search}
                setSendSimpleSearch={setSendSimpleSearch}
                finalArray={finalArray}
                setSelectedOption={setSelectedOption}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                handleView={handleView}
                prevIsDaily={prevIsDaily}
            />
            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={false}
                thead={thead}
                tbody={tbody}
                columnActions={false}
                textNotInformation={'no_information_attendance'}
            />
            {pagination()}
        </>

    )

}

export default AttendanceDayTable
